import "./SCSS/main.scss";

AOS.init();